import { render, staticRenderFns } from "./CardLabels.vue?vue&type=template&id=d5b34c8e&scoped=true&"
import script from "./CardLabels.vue?vue&type=script&lang=js&"
export * from "./CardLabels.vue?vue&type=script&lang=js&"
import style0 from "./CardLabels.vue?vue&type=style&index=0&id=d5b34c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b34c8e",
  null
  
)

export default component.exports